import React from 'react';
import { Clock, MapPin, Phone, Mail, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          {/* Brand */}
          <div>
            <h3 className="font-display text-xl font-bold text-white mb-2">Primeview Glass</h3>
            <p className="text-xs text-gold-400 font-semibold tracking-[0.18em] uppercase mb-4">Transparency Meets Style</p>
            <p className="text-slate-400 text-sm leading-relaxed">
              Seattle's trusted glass railing contractor. Custom glass railings, shower enclosures, and pool fencing across Seattle, Bellevue, and Washington State.
            </p>
          </div>

          {/* Contact */}
          <div>
            <p className="text-white font-semibold text-sm mb-4 uppercase tracking-wide">Contact</p>
            <ul className="space-y-2.5">
              <li><a href="tel:3014335323" className="flex items-center gap-2 text-slate-300 hover:text-gold-400 transition-colors text-sm font-medium"><Phone className="w-3.5 h-3.5 text-brand-400" />(301) 433-5323</a></li>
              <li><a href="tel:6723995323" className="flex items-center gap-2 text-slate-400 hover:text-gold-400 transition-colors text-sm"><Phone className="w-3.5 h-3.5 text-brand-400" />(672) 399-5323</a></li>
              <li><a href="mailto:info@primeviewglass.com" className="flex items-center gap-2 text-slate-400 hover:text-gold-400 transition-colors text-sm"><Mail className="w-3.5 h-3.5 text-brand-400" />info@primeviewglass.com</a></li>
            </ul>
          </div>

          {/* Hours & Location */}
          <div>
            <p className="text-white font-semibold text-sm mb-4 uppercase tracking-wide">Hours &amp; Location</p>
            <div className="space-y-2.5">
              <div className="flex items-center gap-2 text-slate-400 text-sm">
                <Clock className="w-3.5 h-3.5 text-brand-400 flex-shrink-0" />
                Mon–Fri: 8AM–6PM | Sat: 9AM–2PM
              </div>
              <div className="flex items-start gap-2 text-slate-400 text-sm">
                <MapPin className="w-3.5 h-3.5 text-brand-400 flex-shrink-0 mt-0.5" />
                <span>Serving Seattle, WA &amp; Greater Vancouver, BC</span>
              </div>
              <div className="flex items-center gap-2 text-slate-400 text-sm">
                <MapPin className="w-3.5 h-3.5 text-brand-400 flex-shrink-0" />
                Seattle, WA · Greater Vancouver, BC
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col items-center gap-3 sm:grid sm:grid-cols-3 sm:items-center">
          <p className="text-slate-500 text-sm sm:text-left">© 2024 Primeview Glass. All rights reserved.</p>
          <div />
          <div className="hidden sm:block" />
        </div>
        <div className="border-t border-white/5 mt-4 pt-4 text-center">
          <a
            href="https://rightframework.tech"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-slate-400 hover:text-white hover:underline transition-colors duration-200 inline-flex items-center gap-1"
          >
            Built by Right Framework Digital Inc.
            <ExternalLink size={12} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
